import { Group } from "@fairfleet/geotab";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { useGroups } from "@/hooks/groups/useGroups";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

export default function GroupsDetail({ row }: { row: DeviceStatusOverviewData }) {
  const { data: groups = [] } = useGroups();

  const matchedGroups = (row.device.groups ?? [])
    .map(({ id }) => groups.find(group => group.id === id))
    .filter(Boolean) as Group[];
  return (
    <Box sx={{ display: "flex", gap: 1, overflowY: "scroll" }}>
      {matchedGroups.map(group => {
        let bgColor = group.color
          ? `rgba(${group.color.r}, ${group.color.g}, ${group.color.b}, ${200 / 255})`
          : "#ccc";

        return (
          <Chip
            key={group.id}
            label={group.name}
            size="small"
            sx={{
              backgroundColor: bgColor,
              color: "#fff",
              fontWeight: 500,
            }}
          />
        );
      })}
    </Box>
  );
}
